import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getOrderHistory } from '../services/api';

function formatRupiah(n) { return 'Rp ' + n.toLocaleString('id-ID'); }

const badgeMap = {
  pending:    'badge-pending',
  paid:       'badge-paid',
  processing: 'badge-processing',
  completed:  'badge-completed',
  cancelled:  'badge-cancelled',
};

const statusLabel = {
  pending:    'Menunggu',
  paid:       'Lunas',
  processing: 'Diproses',
  completed:  'Selesai',
  cancelled:  'Batal',
};

export default function HistoryPage() {
  const [phone, setPhone] = useState('');
  const [orders, setOrders] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async e => {
    e.preventDefault();
    if (!phone.trim()) return;
    setLoading(true); setError(''); setOrders(null);
    try {
      const res = await getOrderHistory(phone.trim());
      setOrders(res.data.data);
    } catch { setError('Gagal mengambil data. Coba lagi.'); }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 640, margin: '0 auto' }} className="page-enter">
      <div className="page-title">Riwayat Pesanan</div>

      <div className="section-box">
        <div className="sec-title">// cari pesanan</div>
        <p style={{ color: 'var(--text2)', fontSize: '0.87rem', marginBottom: 16 }}>
          Masukkan nomor HP yang digunakan saat checkout.
        </p>
        <form className="search-wrap" onSubmit={handleSearch}>
          <input
            className="form-control"
            placeholder="08xxxxxxxxxx"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            style={{ fontFamily: 'var(--mono)' }}
          />
          <button type="submit" className="btn btn-ghost" disabled={loading}>
            {loading ? '⏳' : 'Cari'}
          </button>
        </form>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {orders !== null && (
        orders.length === 0 ? (
          <div className="empty-state">
            <span className="empty-icon">📭</span>
            <p>Tidak ada riwayat pesanan untuk nomor ini</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div className="sec-title">// ditemukan {orders.length} pesanan</div>
            {orders.map((order, i) => (
              <div
                key={order.orderId}
                className="section-box"
                style={{ marginBottom: 0, animationDelay: `${i * 0.06}s`, cursor: 'default' }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                  <div>
                    <div style={{ fontFamily: 'var(--mono)', fontWeight: 700, fontSize: '0.88rem', marginBottom: 4 }}>
                      {order.orderId}
                    </div>
                    <div style={{ color: 'var(--text3)', fontSize: '0.78rem' }}>
                      {new Date(order.createdAt).toLocaleString('id-ID')}
                    </div>
                  </div>
                  <span className={`badge ${badgeMap[order.status] || ''}`}>
                    {statusLabel[order.status] || order.status}
                  </span>
                </div>

                <div style={{ marginBottom: 14 }}>
                  {order.items.map((item, j) => (
                    <div key={j} style={{ fontSize: '0.83rem', color: 'var(--text2)', marginBottom: 2, display: 'flex', alignItems: 'center', gap: 6 }}>
                      <span style={{ color: 'var(--primary)', fontSize: '0.7rem' }}>▸</span>
                      {item.name} <span style={{ fontFamily: 'var(--mono)', color: 'var(--text3)' }}>×{item.quantity}</span>
                    </div>
                  ))}
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ fontFamily: 'var(--mono)', fontWeight: 800, color: 'var(--primary)', fontSize: '1rem' }}>
                    {formatRupiah(order.totalAmount)}
                  </div>
                  <Link to={`/order/${order.orderId}`} className="btn btn-ghost" style={{ padding: '6px 14px', fontSize: '0.82rem' }}>
                    Detail →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )
      )}
    </div>
  );
}
